import { Outlet } from 'react-router-dom'
import styles from './AuthLayout.module.css'

export default function AuthLayout() {
  return (
    <div className={styles.container}>
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  )
}
